import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAg2Pv4MLTeCg2A_Th1Ktb-pJw9UOP50AI",
  authDomain: "hyperchattr.firebaseapp.com",
  databaseURL: "https://hyperchattr.firebaseio.com",
  projectId: "hyperchattr",
  storageBucket: "hyperchattr.appspot.com",
  messagingSenderId: "603801822709",
  appId: "1:603801822709:web:1894230b924ac08f8facbc",
  measurementId: "G-88WWF0E15N",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
